export function addPreviewFlag(arr) {
  return arr.map((obj) => {
    if (!obj.componentData) {
      return obj;
    }
    const updatedComponentData = {};

    for (const key in obj.componentData) {
      if (obj.componentData.hasOwnProperty(key)) {
        updatedComponentData[key] = {
          ...obj.componentData[key],
          isPreview: true,
        };
      }
    }

    return {
      ...obj,
      componentData: updatedComponentData,
    };
  });
}
